import { Factory, AlarmOutlined, Notifications, TimerOutlined, BuildOutlined, BugReport, Speed, Scale, Block, Balance, CalendarMonth, Construction, Dangerous, Recycling, Error, ScienceOutlined, Star } from "@mui/icons-material";

export const iconList = [
    { id: 1, name: "Alarm", icon: <AlarmOutlined /> },
    { id: 2, name: "Notification", icon: <Notifications /> },
    { id: 3, name: "Timer", icon: <TimerOutlined /> },
    { id: 4, name: "Build", icon: <BuildOutlined /> },
    { id: 5, name: "Construction", icon: <Construction /> },
    { id: 6, name: "Factory", icon: <Factory /> },
    { id: 7, name: "Bug", icon: <BugReport /> },
    { id: 8, name: "Speed", icon: <Speed /> },
    { id: 9, name: "Scale", icon: <Scale /> },
    { id: 10, name: "Balance", icon: <Balance /> },
    { id: 11, name: "Science", icon: <ScienceOutlined /> },
    { id: 12, name: "Block", icon: <Block /> },
    { id: 13, name: "Dangerous", icon: <Dangerous /> },
    { id: 14, name: "Error", icon: <Error /> },
    { id: 15, name: "CalendarMonth", icon: <CalendarMonth /> },
    { id: 16, name: "Recycling", icon: <Recycling /> },
    { id: 17, name: "Star", icon: <Star /> },
];